import { useState } from "react";
import { useTranslation } from "react-i18next";

import _ from "lodash";
import styled, { css } from "styled-components";

import { Button, Input, TExtra } from "components/ui-kit/styled-templates";

interface IProps {
    value: string[];
    onChange: (value: { target: { value: string[] } }) => void;
}

export const TagsInput = (props: IProps) => {
    const { t } = useTranslation();

    const { value: tags, onChange } = props;

    const [value, setValue] = useState(``);

    const handlers = {
        onButtonCloick: () => {
            if (!_.isEmpty(value)) {
                onChange({ target: { value: [...tags, value] } });
            }
            setValue(``);
        },
    };

    return (
        <>
            <Tags
                tags={tags}
                extra="margin-bottom: 10px;"
                mode="edit"
                onDelete={(indexToDelete) => onChange({ target: { value: tags?.filter?.((i, j) => j !== indexToDelete) } })}
            />
            <Row>
                <div>
                    <Input value={value} onChange={(e) => setValue(e.target.value)} maxLength={25} />
                </div>
                <Button onClick={handlers.onButtonCloick}>{t("yuxjo1fq5w")}</Button>
            </Row>
        </>
    );
};

interface TSelectOption {
    label: string;
    value: string;
}

export const TagsSelect = (props: IProps & { options: TSelectOption[]; extra?: TExtra }) => {
    const { value: selectedTags, onChange, options, extra } = props;

    console.log('TagsSelect: render: value = ', selectedTags);

    const handlers = {
        onTagClick: (value: any) => () => {
            onChange({ target: { value } });
        },
    };

    return (
        <Row extra={extra}>
            {options?.map?.(({ label, value }, index) => (
                <Tag key={index} selected={selectedTags?.includes?.(value)} onClick={handlers.onTagClick(value)}>
                    {label}
                </Tag>
            ))}
        </Row>
    );
};

const Tags = (props: { tags: string[]; extra?: TExtra; onDelete?: (indexToDelete: number) => void; mode?: "veiw" | "edit" }) => {
    const { tags, extra, onDelete, mode = "veiw" } = props;

    return (
        <Row extra={extra}>
            {tags?.map?.((tag, index) => (
                <Tag key={index}>
                    {tag}
                    {mode === "edit" && <Cros onClick={() => onDelete(index)} />}
                </Tag>
            ))}
        </Row>
    );
};

const Cros = styled.div`
    width: 10px;
    height: 10px;
    background: url("${require(`assets/icons/cross.svg`).default}") no-repeat center center / contain;
    cursor: pointer;
`;

const Row = styled.div<{ extra?: TExtra }>`
    display: flex;
    width: 100%;
    flex-wrap: wrap;
    gap: 15px;

    ${({ extra }) => extra}
`;

export const Tag = styled.div<{ selected?: boolean }>`
    display: flex;
    padding: 4px 12.5px;
    box-sizing: border-box;
    border: 1px solid #e0e0e0;
    border-radius: 9999px;
    align-items: center;
    gap: 10px;
    cursor: pointer;

    font-size: 13px;
    line-height: 20px;
    color: rgba(0, 0, 0, 0.5);

    ${({ selected = true }) =>
        selected &&
        css`
            background: rgba(0, 161, 154, 0.1);
            border: 1px solid rgba(0, 161, 154, 0.1);
        `}
`;

export default Tags;
